module.exports = __webpack_public_path__ + "static/media/falabella_logo.6be9ec2b.png";